import { Component, type OnInit, inject } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { switchMap } from "rxjs/operators";
import { AuthServerProvider, LoginService } from "../../core";
import { SearchBarService } from "../../shared/search-bar/search-bar.service";

@Component({
    selector: "app-dashboard",
    templateUrl: "./impersonate.component.html",
    standalone: false,
})
export class ImpersonateComponent implements OnInit {
    private authJWTService = inject(AuthServerProvider);
    protected activatedRoute = inject(ActivatedRoute);
    private loginService = inject(LoginService);
    private router = inject(Router);
    private searchBarService = inject(SearchBarService);

    ngOnInit(): void {
        this.authJWTService
            .logout()
            .pipe(
                switchMap(() => {
                    return this.activatedRoute.queryParams;
                }),
            )
            .subscribe((params) => {
                this.loginViaImpersonate(params["token"]);
            });
    }

    loginViaImpersonate(token: string): void {
        this.loginService.loginViaImpersonate(token).subscribe(() => {
            this.router.navigate(["/"]);
            this.searchBarService.clearSearchBarFromLocalStorage();
        });
    }
}
